import React from 'react'
import PropTypes from 'prop-types'
import { List, fromJS } from 'immutable'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/advanced/tags-list.scss'

export default class TagsList extends PureDataComponent {
  static propTypes = {
    tags: PropTypes.oneOfType([PropTypes.instanceOf(List), PropTypes.array]),
    onDelete: PropTypes.func
  }

  constructor(...args) {
    super(...args);
    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(tag, index) {
    const { onDelete } = this.props
    return 'function' == typeof onDelete
      ? () => {
          onDelete(tag, index)
          return false
        }
      : null
  }

  render() {
    const { tags } = this.props
    const tList = tags ? (List.isList(tags) ? tags : fromJS(tags)) : List()

    return (
      <div className="rfd-ui-tags-list">
        {tList &&
          (() =>
            tList
              .map((o, oi) => (
                <div className="rfd-ui-tag" key={oi}>
                  <span className="rfd-ui-tag-text">
                    {o.has('category') && <span className="rfd-ui-tag-category">{o.get('category')}: </span>}
                    {o.get('value') ? o.get('value') : o.get('text')}
                  </span>
                  <i className="icon-aytmfd-delete" onClick={this.onDelete(o, oi)} />
                </div>
              ))
              .toArray())()}
      </div>
    )
  }
}
